var _excluded = ["hideOverlay", "children", "zIndex", "classNames", "className", "onClose", "closeOnOverlayClick", "closeOnEscape", "size", "hideCloseButton", "portalTarget", "noPortal", "data-qa", "matchMedias"],
  _excluded2 = ["header", "error", "children", "mainAction", "secondAction", "cancelAction", "footerTheme", "contentTheme", "contentType", "data-qa", "hideOverlay", "zIndex", "classNames", "onBackClick", "backLinkContent", "className", "closeOnOverlayClick", "closeOnEscape", "size", "additionalContent"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef, useEffect, useRef, useCallback } from "react";
import * as ReactDOM from "react-dom";
import Icon from "@components/icon";
import { zIndexSystem, joinCn } from "@ati/uti";
import { useMatchMedia } from "@ati/hooks";
import Header from "./components/Header";
import Content from "./components/Content";
import Footer from "./components/Footer";
import ActionWrapper from "./components/ActionWrapper";
import styles from "./Popup.module.scss";
var zIndexDefault = {
  popup: zIndexSystem.abovePopup,
  // glz-z-above-popup
  closeButton: zIndexSystem.aboveContent,
  overlay: zIndexSystem.popup // glz-z-popup
};

var defaultClassNames = {};
var Popup = forwardRef((_ref, ref) => {
  var _matchMedias$mediumSi, _matchMedias$smallSiz;
  var {
      hideOverlay = false,
      children,
      zIndex = zIndexDefault,
      classNames = defaultClassNames,
      className,
      onClose,
      closeOnOverlayClick = true,
      closeOnEscape = true,
      size = "medium",
      hideCloseButton,
      portalTarget,
      noPortal,
      "data-qa": dataQa = "popup",
      matchMedias
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  var currentZIndex = _objectSpread(_objectSpread({}, zIndexDefault), zIndex);
  var isMediumPopupMobile = useMatchMedia((_matchMedias$mediumSi = matchMedias === null || matchMedias === void 0 ? void 0 : matchMedias.mediumSize) !== null && _matchMedias$mediumSi !== void 0 ? _matchMedias$mediumSi : "(max-width: 640px)");
  var isSmallPopupMobile = useMatchMedia((_matchMedias$smallSiz = matchMedias === null || matchMedias === void 0 ? void 0 : matchMedias.smallSize) !== null && _matchMedias$smallSiz !== void 0 ? _matchMedias$smallSiz : "(max-width: 448px)");
  var popupContentRef = useRef(null);
  var handleCloseOnEsc = useCallback(event => {
    if (closeOnEscape) {
      if (event instanceof KeyboardEvent && event.key === "Escape") {
        onClose === null || onClose === void 0 ? void 0 : onClose(event);
      }
    }
  }, [closeOnEscape, onClose]);
  var handleOverlayClick = event => {
    if (closeOnOverlayClick && onClose && popupContentRef && popupContentRef.current && !popupContentRef.current.contains(event.target)) {
      onClose(event);
    }
  };
  useEffect(() => {
    document.addEventListener("keyup", handleCloseOnEsc);
    return () => {
      document.removeEventListener("keyup", handleCloseOnEsc);
    };
  }, []);
  var isMobile = size === "small" ? isSmallPopupMobile : isMediumPopupMobile;
  var popupRender = /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: joinCn(styles["outer-wrapper"], isMobile && styles["is-mobile"], isMobile && "is-popup-component-mobile", hideOverlay && styles["overlay-invisible"], classNames.outerWrapper),
    style: {
      zIndex: currentZIndex.overlay
    },
    role: "presentation",
    tabIndex: -1,
    onMouseDown: handleOverlayClick,
    "data-qa": dataQa
  }, /*#__PURE__*/React.createElement("div", {
    className: styles["content-layout"]
  }, /*#__PURE__*/React.createElement("div", _extends({
    ref: popupContentRef,
    "data-qa": "popup-window",
    style: {
      zIndex: currentZIndex.popup
    },
    className: joinCn(styles.popup, size !== "no-size" && styles["size-".concat(size)], classNames.popup, className)
  }, rest), !hideCloseButton && /*#__PURE__*/React.createElement("button", {
    style: {
      zIndex: currentZIndex.closeButton
    },
    "data-qa": "popup-close-button",
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    onClick: onClose,
    type: "button",
    className: joinCn(styles["close-button"], classNames.closeButton)
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "ic_close",
    width: 24
  })), children)));
  return noPortal ? popupRender : ReactDOM.createPortal(popupRender, portalTarget || document.getElementsByTagName("body")[0]);
});
var Builder = forwardRef((_ref2, ref) => {
  var {
      header,
      error,
      children,
      mainAction,
      secondAction,
      cancelAction,
      footerTheme,
      contentTheme = "white",
      contentType,
      "data-qa": dataQa = "popup",
      hideOverlay = false,
      zIndex = zIndexDefault,
      classNames = defaultClassNames,
      onBackClick,
      backLinkContent,
      className,
      closeOnOverlayClick = true,
      closeOnEscape = true,
      size = "medium",
      additionalContent
      // popup props inside rest
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React.createElement(Popup, _extends({
    "data-qa": dataQa,
    hideOverlay: hideOverlay,
    zIndex: zIndex,
    classNames: classNames,
    className: className,
    closeOnOverlayClick: closeOnOverlayClick,
    closeOnEscape: closeOnEscape,
    size: size
  }, rest, {
    ref: ref
  }), !!header && /*#__PURE__*/React.createElement(Header, {
    onBackClick: onBackClick,
    backLinkContent: backLinkContent
  }, header), !!children && /*#__PURE__*/React.createElement(Content, {
    theme: contentTheme,
    type: contentType
  }, children), !!error && /*#__PURE__*/React.createElement(Content, {
    theme: "error"
  }, error), (mainAction || secondAction || cancelAction) && /*#__PURE__*/React.createElement(Footer, {
    theme: footerTheme
  }, mainAction && /*#__PURE__*/React.createElement(ActionWrapper, {
    type: "main"
  }, mainAction), cancelAction && /*#__PURE__*/React.createElement(ActionWrapper, {
    type: "cancel"
  }, cancelAction), secondAction && /*#__PURE__*/React.createElement(ActionWrapper, {
    type: "second"
  }, secondAction)), additionalContent);
});
Object.defineProperty(Popup, "Content", {
  get: () => Content
});
Object.defineProperty(Popup, "Footer", {
  get: () => Footer
});
Object.defineProperty(Popup, "Header", {
  get: () => Header
});
Object.defineProperty(Popup, "Builder", {
  get: () => Builder
});
Object.defineProperty(Popup, "ActionWrapper", {
  get: () => ActionWrapper
});
export default Popup;